import HomeOverview from '../../features/home/layouts/overview';

export default function HomePage() {
    return <HomeOverview />;
}
